import { render, staticRenderFns } from "./DynamicBackground.vue?vue&type=template&id=07d4e9d4&scoped=true&"
import script from "./js/dynamic-background.js?vue&type=script&lang=js&"
export * from "./js/dynamic-background.js?vue&type=script&lang=js&"
import style0 from "./DynamicBackground.vue?vue&type=style&index=0&id=07d4e9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d4e9d4",
  null
  
)

export default component.exports